export const DATADOG_CONFIG = {
  SITE: 'us5.datadoghq.com',
  SERVICE: 'infocenter-v2',
}
